<app-centre-small-opener>
    <h2 mat-dialog-title dialogTitle class="title mar-b-5">Preview or Share Agenda</h2>
     
    <div mat-dialog-content contentContainer class="row">
        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 text-end">
          <!-- <button  mat-raised-button actions color = "primary" class="button-container mar-l-8" (click) = "shareAgenda()">
            Share
          </button> -->
            <div class="align-items-center inline">
                        <input type="radio" (change)="showAddParticipants()" class="margin" checked id="participants"
                             name="group-1" />
                        <label for="participants">Send to selected participants</label>
                    </div> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;

                    <div class="align-items-center inline">
                        <input type="radio" id="all-participants" class="margin" name="group-1"
                            (change)="hideAddParticipants()" />
                        <label for="all-participants">Send to all participants</label>
                    </div>



                    <mat-form-field *ngIf="particToggler" class="checkList" id="check">
                        <mat-label>Select the participants</mat-label>
                        <mat-select disableOptionCentering panelClass="common-drop-down-class" id-=""
                            [formControl]="toppingsControl" multiple (blur)="callTrigger()">

                            <mat-select-trigger>
                                <mat-chip-list>
                                    <mat-chip *ngFor="let topping of toppingsControl.value" [removable]="true"
                                        (removed)="onToppingRemoved(topping,0)">
                                        {{ topping.attendeeName }}
                                        <mat-icon matChipRemove>cancel</mat-icon>
                                    </mat-chip>
                                </mat-chip-list>
                            </mat-select-trigger>

                            <mat-option *ngFor="let topping of data.meetingInfo.attendeeList"
                                [value]="topping">{{topping.attendeeName}}</mat-option>
                        </mat-select>
                    </mat-form-field>
        </div>
        <div class="col-lg-12 col-sm-12" iframe >
            <iframe id="previewMinutes" [hidden]="isEmptyMomCont" src=""
                type="application/pdf" width="100%" height="100vh"></iframe>
        </div>
    </div>
    <div class="d-flex justify-content-end" actions>
      <button mat-raised-button actions color = "primary" class="button-container mar-l-8" (click) = "shareAgenda()">
        SHARE
      </button>
      <button mat-raised-button mat-dialog-close type="reset" color = "primary" actions class="button-container mar-l-8">
        CANCEL
      </button>
  </div>
</app-centre-small-opener>